import type { Language } from '../i18n'

export const getLanguageFromUrl = (search: string): Language => {
	return new URLSearchParams(search).get('lang') === 'de' ? 'de' : 'en'
}
